module.exports = __webpack_public_path__ + "assets/plus-gray.b6b34deb.svg";